import React, { useEffect, useState } from "react";
import ReactQuill from "react-quill"; // Import ReactQuill
import "react-quill/dist/quill.snow.css"; //
import "./AddProductCss/AddProduct.css";
import "./EditProductCss/EditProduct.css";
import AdminLayout from "../AdminLayout";
import useProductHook from "./hooks/useProductHook";

const NewProduct = () => {
  const {
    selectedProductAttributes,
    setSelectedProductAttributes,
    createProductType,
    checkCategoryFormValues,
    product_errors,
    product_register,
    product_handleSubmit,
    product_watch,
    product_setValue,
    product_reset,
    category_register,
    category_handleSubmit,
    category_errors,
    category_watch,
    category_setValue,
    category_reset,
    handleToggleChange,
    modules,
    formats,
    handleChange,
    totalSteps,
    categorySteps,
    stepLabels,
    categoryLabels,
    handleNext,
    handleCategoryNext,
    handleCategoryBack,
    handleBack,
    handleFileUpload,
    handleFileUploadCategory,
    handleFileUploadAttribute,

    isToggleChecked,
    setIsToggleChecked,
    setCount,
    content,
    setContent,
    currentStep,
    setCurrentStep,
    currentCategoryStep,
    setCurrentCategoryStep,
    uploadedImages,
    setUploadedImages,
    uploadCategoryImages,
    setUploadedCategoryImages,
    uploadedImagesAttribute,
    setUploadedAttributeImages,
    formError,
    productForm,
    fetchAllCategories,
    categoryData,
    parentCategoryData,
    categoryFormSubmit,
    attribute_handleSubmit,
    attribute_errors,
    attribute_register,
    attribute_watch,
    attribute_setValue,
    attribute_reset,
    attributeFormSubmit,
    checkAttributeUnfilledValue,
    attributeData,
    setAttributeData,
    fetchAttributes,
    productType_register,
    productType_handleSubmit,
    productType_errors,
    productType_watch,
    productType_setValue,
    productType_reset,
    productTypeData,
    setProductTypeData,
    fetchAllProductType,
    checkProductFormValues,
    handleProductSubmitForm,
    count,
    rows,
  } = useProductHook();

  useEffect(() => {
    fetchAllCategories();
    fetchAttributes();
    fetchAllProductType();
  }, [currentStep]);

  useEffect(() => {
    console.log("count", count);
    product_setValue("requirement_count", count);
  }, [count]);

  // handle attribute select
  const handleAttributeSelect = (attributeId) => {
    if (selectedProductAttributes.includes(attributeId)) {
      setSelectedProductAttributes(
        selectedProductAttributes.filter((id) => id !== attributeId)
      );
    } else {
      setSelectedProductAttributes([...selectedProductAttributes, attributeId]);
    }
  };

  const RenderStepContent = ({ step = step }) => {
    switch (step) {
      case 1:
        return (
          <form
            id="product_form1"
            onSubmit={product_handleSubmit(handleProductSubmitForm)}
          >
            <div className="container">
              <div className="row from_wepper">
                {/* product name */}
                <div className="col-lg-6">
                  <div className="form-group ">
                    <label htmlFor="product_name">Product Name</label>
                    <div className="add_user_input">
                      <input
                        type="text"
                        id="product_name"
                        name="product_name"
                        className="form-control"
                        placeholder="Jone"
                        {...product_register("product_name", {
                          required: " * Product Name is required",
                        })}
                      />
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                      >
                        <g clipPath="url(#clip0_771_7773)">
                          <path
                            d="M12.6667 4.66733C12.6667 7.244 10.5773 9.334 8 9.334C5.42267 9.334 3.33333 7.244 3.33333 4.66733C3.33333 2.08933 5.42267 0 8 0C10.5773 0 12.6667 2.08933 12.6667 4.66733V4.66733ZM11.6013 9.454C10.5973 10.212 9.352 10.6673 8 10.6673C6.64667 10.6673 5.40067 10.2107 4.39533 9.45267C1.68067 10.648 0 14.37 0 16H16C16 14.3847 14.2667 10.6627 11.6013 9.454V9.454Z"
                            fill="#6F757E"
                          ></path>
                        </g>
                        <defs>
                          <clipPath id="clip0_771_7773">
                            <rect width="16" height="16" fill="white"></rect>
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                    {product_errors?.product_name && (
                      <p id="alert" className="alert">
                        {product_errors?.product_name?.message}
                      </p>
                    )}
                  </div>
                </div>

                {/* product sku */}
                <div className="col-lg-6">
                  <div className="form-group ">
                    <label htmlFor="product_sku">
                      SKU
                      <span className="required_text">*</span>
                    </label>
                    <div className="add_user_input">
                      <input
                        type="text"
                        name="product_sku"
                        className="form-control"
                        placeholder="SKU-001"
                        {...product_register("product_sku", {
                          required: " * Product SKU is required",
                        })}
                      />
                    </div>
                    {product_errors?.product_sku && (
                      <p id="alert" className="alert">
                        {product_errors?.product_sku?.message}
                      </p>
                    )}
                  </div>
                </div>

                {/* category */}
                <div className="col-lg-6">
                  <div className="form-group">
                    <label htmlFor="product_category">
                      Category
                      <span className="required_text">*</span>
                    </label>
                    <div className="add_user_input">
                      <select
                        name="product_category"
                        id="product_category"
                        className="form-control"
                        {...product_register("product_category", {
                          required: " * Product Category is required",
                        })}
                      >
                        <option defaultValue="" disabled>
                          Select Category
                        </option>
                        {categoryData.map((category, index) => (
                          <option key={index} value={category.id}>
                            {category.name}
                          </option>
                        ))}
                      </select>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="10"
                        viewBox="0 0 18 10"
                        fill="none"
                      >
                        <path
                          d="M2 1.5L9 8.5L16 1.5"
                          stroke="#26395C"
                          strokeWidth="2"
                          strokeLinecap="square"
                        ></path>
                      </svg>
                    </div>
                    {product_errors?.product_category && (
                      <p id="alert" className="alert">
                        {product_errors?.product_category?.message}
                      </p>
                    )}
                  </div>
                </div>

                {/* quantity */}
                <div className="col-lg-6">
                  <div className="form-group ">
                    <label htmlFor="product_qty">
                      QTY
                      <span className="required_text">*</span>
                    </label>
                    <div className="add_user_input">
                      <input
                        type="text"
                        name="product_qty"
                        id="product_qty"
                        className="form-control"
                        placeholder="Enter Quantity"
                        {...product_register("product_qty", {
                          required: " * Product Quantity is required",
                        })}
                      />
                    </div>
                    {product_errors?.product_qty && (
                      <p id="alert" className="alert">
                        {product_errors?.product_qty?.message}
                      </p>
                    )}
                  </div>
                </div>

                {/* description */}
                <div className="col-lg-12">
                  <div
                    style={{
                      padding: "20px",
                    }}
                  >
                    <ReactQuill
                      modules={modules}
                      formats={formats}
                      theme="snow"
                      style={{ height: "100px", marginBottom: "20px" }}
                      onChange={(value) =>
                        product_setValue("product_description", value)
                      }
                      onBlur={() =>
                        product_register("product_description", {
                          required: " * Product Description is required",
                        })
                      }
                    />
                  </div>
                </div>

                {/* submit & back button */}
                <div className="setp_btn row mt-3">
                  {currentStep > 1 && (
                    <div className="col-lg-6">
                      <p onClick={handleBack}>Back</p>
                    </div>
                  )}
                  {currentStep <= totalSteps && (
                    <div className="col-lg-6">
                      <div
                        className={`continue_step ${
                          currentStep === 1 ? "with_active_next_btn" : ""
                        }`}
                        onClick={() => {
                          if (currentStep === totalSteps) {
                            alert("Product Data is Done ");
                          } else if (
                            Object.keys(product_errors).length === 0 &&
                            checkProductFormValues()
                          ) {
                            handleNext();
                          } else {
                            console.log("there is still  data pending");
                          }
                        }}
                      >
                        <p className="active">
                          {currentStep === totalSteps ? "Save" : "Next"}
                        </p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </form>
        );
      case 2:
        return (
          <form onSubmit={product_handleSubmit(handleProductSubmitForm)}>
            <div className="container">
              <h2>Media</h2>
              <div className="row form_wepper">
                <div className="col-lg-12">
                  <div className="media_upload_container">
                    <div className="media_preview_row">
                      {uploadedImages.map((image, index) => (
                        <div key={index} className="media_preview_slot">
                          <img
                            src={image}
                            alt={`Uploaded Preview ${index + 1}`}
                            className="uploaded_image"
                          />
                          <button
                            className="close_icon"
                            onClick={() => {
                              setUploadedImages((prevImages) =>
                                prevImages.filter(
                                  (_, imgIndex) => imgIndex !== index
                                )
                              );
                            }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="13"
                              height="12"
                              viewBox="0 0 13 12"
                              fill="none"
                            >
                              <path
                                d="M6.5 0C3.20445 0 0.5 2.70445 0.5 6C0.5 9.29555 3.20445 12 6.5 12C9.79555 12 12.5 9.29555 12.5 6C12.5 2.70445 9.79555 0 6.5 0ZM9.48312 7.98886L8.48886 8.98312L6.5 6.99427L4.51114 8.98312L3.51688 7.98886L5.50573 6L3.51688 4.01114L4.51114 3.01688L6.5 5.00573L8.48886 3.01688L9.48312 4.01114L7.49427 6L9.48312 7.98886Z"
                                fill="#313131"
                              />
                            </svg>
                          </button>
                        </div>
                      ))}
                    </div>
                    <div className="upload_area">
                      <input
                        type="file"
                        name="media"
                        className="file_input"
                        multiple
                        accept="image/jpeg, image/jpg, image/png"
                        onChange={handleFileUpload}
                      />
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="65"
                        height="64"
                        viewBox="0 0 65 64"
                        fill="none"
                      >
                        <g clipPath="url(#clip0_900_10944)">
                          <path
                            d="M52.444 26.912C51.8787 16.376 43.1827 8 32.5 8C21.82 8 13.1213 16.376 12.556 26.912C5.70267 28.1467 0.5 34.128 0.5 41.3333C0.5 49.432 7.068 56 15.1667 56H49.8333C57.932 56 64.5 49.432 64.5 41.3333C64.5 34.128 59.2973 28.1467 52.444 26.912ZM32.5 24L43.1667 34.6667H35.1667V45.3333H29.8333V34.6667H21.8333L32.5 24Z"
                            fill="#10849B"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_900_10944">
                            <rect
                              width="64"
                              height="64"
                              fill="white"
                              transform="translate(0.5)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                      <i className="upload_icon"></i>
                      <p>
                        Drop your image here or{" "}
                        <span className="browse_link">Browse</span>
                      </p>
                      <p className="supported_formats">
                        Support: JPG, JPEG, PNG
                      </p>
                    </div>
                  </div>
                </div>

                {/* submit & back button */}
                <div className="setp_btn row mt-3">
                  {currentStep > 1 && (
                    <div className="col-lg-6">
                      <p onClick={handleBack}>Back</p>
                    </div>
                  )}
                  {currentStep <= totalSteps && (
                    <div className="col-lg-6">
                      <div
                        className={`continue_step ${
                          currentStep === 1 ? "with_active_next_btn" : ""
                        }`}
                        onClick={() => {
                          if (currentStep === totalSteps) {
                            alert("Product Data is Done ");
                          } else if (checkProductFormValues() === true) {
                            console.log(
                              "check rpoduct form values",
                              checkProductFormValues()
                            );
                            handleNext();
                          } else {
                            console.log("there is still  data pending");
                          }
                        }}
                      >
                        <p className="active">
                          {currentStep === totalSteps ? "Save" : "Next"}
                        </p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </form>
        );

      case 3:
        return (
          <form onSubmit={product_handleSubmit(handleProductSubmitForm)}>
            <div className="container">
              <h2> Social</h2>
              <div className="row from_wepper">
                {/* shopify */}
                <div className="col-lg-6">
                  <div className="add_user_input">
                    <input
                      type="text"
                      name="shopify"
                      className="form-control"
                      placeholder="Shoppify Handle"
                      {...product_register("shopify", {
                        required: false,
                      })}
                    />
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M14.014 3.08086C14.0007 3.00013 13.9211 2.95586 13.8547 2.95065C13.7883 2.94544 12.4987 2.92852 12.4987 2.92852C12.4987 2.92852 11.4187 2.00404 11.3124 1.90898C11.2062 1.81523 10.9982 1.84388 10.917 1.86471C10.9155 1.86471 10.7149 1.9207 10.374 2.01315C10.318 1.85039 10.2339 1.65117 10.1143 1.45065C9.73073 0.803516 9.1671 0.461068 8.4869 0.459766C8.48543 0.459766 8.48543 0.459766 8.48395 0.459766C8.43674 0.459766 8.38952 0.463672 8.34231 0.467578C8.32165 0.446745 8.30247 0.425912 8.28034 0.405078C7.98377 0.12513 7.60457 -0.0102862 7.14865 0.0014326C6.27075 0.023568 5.39579 0.583464 4.68609 1.57826C4.18738 2.27747 3.80671 3.15638 3.699 3.83737C2.69126 4.11341 1.98598 4.30612 1.96975 4.31003C1.46072 4.45065 1.44449 4.46497 1.37809 4.88815C1.33235 5.20716 0 14.297 0 14.297L11.1619 16.0001L16 14.9389C16 14.9389 14.0258 3.16159 14.014 3.08086ZM9.81483 2.1655C9.5581 2.23581 9.26595 2.31523 8.94873 2.40247C8.94283 2.01055 8.88971 1.46367 8.68167 0.992318C9.34858 1.103 9.67613 1.76836 9.81483 2.1655ZM8.36444 2.56263C7.78015 2.72279 7.14128 2.89727 6.50092 3.07175C6.68093 2.46367 7.02324 1.8569 7.44227 1.45977C7.59867 1.31133 7.81704 1.14727 8.07525 1.05352C8.3187 1.50013 8.37034 2.13425 8.36444 2.56263ZM7.16783 0.517058C7.3744 0.513151 7.54703 0.553516 7.69605 0.639453C7.4585 0.747526 7.2298 0.903776 7.01439 1.1069C6.45666 1.63555 6.02877 2.45456 5.85909 3.24622C5.32792 3.39076 4.80708 3.53398 4.32903 3.66419C4.63003 2.4194 5.81335 0.550912 7.16783 0.517058Z"
                        fill="#6F757E"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M13.8529 2.95052C13.7865 2.94531 12.4969 2.92839 12.4969 2.92839C12.4969 2.92839 11.4169 2.00391 11.3107 1.90885C11.2708 1.8737 11.2177 1.85547 11.1602 1.84766V15.9987L15.9967 14.9375C15.9967 14.9375 14.0226 3.16146 14.0108 3.08073C14.0004 3 13.9193 2.95573 13.8529 2.95052Z"
                        fill="#5E8E3E"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M8.48059 5.14578L7.91843 7.00124C7.91843 7.00124 7.29136 6.74994 6.5492 6.79031C5.4603 6.8515 5.4485 7.45697 5.45882 7.60932C5.51784 8.43874 7.99073 8.61973 8.1309 10.5637C8.24009 12.0924 7.21168 13.138 5.73031 13.2213C3.95237 13.3203 2.97266 12.3945 2.97266 12.3945L3.3489 10.9804C3.3489 10.9804 4.33452 11.6367 5.12242 11.5924C5.63736 11.5637 5.82179 11.194 5.80261 10.9322C5.72588 9.8502 3.71039 9.914 3.5835 8.13536C3.47579 6.63926 4.58977 5.12234 7.04791 4.98562C7.99663 4.93223 8.48059 5.14578 8.48059 5.14578Z"
                        fill="white"
                      />
                    </svg>
                  </div>
                </div>

                {/* facebook */}
                <div className="col-lg-6">
                  <div className="add_user_input">
                    <input
                      type="text"
                      name="facebook"
                      className="form-control"
                      placeholder="Facebook"
                      {...product_register("facebook", {
                        required: false,
                      })}
                    />
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <g clipPath="url(#clip0_1009_10101)">
                        <path
                          d="M8 0C3.582 0 0 3.582 0 8C0 12.418 3.582 16 8 16C12.418 16 16 12.418 16 8C16 3.582 12.418 0 8 0ZM10 5.33333H9.1C8.74133 5.33333 8.66667 5.48067 8.66667 5.852V6.66667H10L9.86067 8H8.66667V12.6667H6.66667V8H5.33333V6.66667H6.66667V5.128C6.66667 3.94867 7.28733 3.33333 8.686 3.33333H10V5.33333Z"
                          fill="#6F757E"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_1009_10101">
                          <rect width="16" height="16" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                </div>

                {/* twitter */}
                <div className="col-lg-6">
                  <div className="add_user_input">
                    <input
                      type="text"
                      name="twitter"
                      className="form-control"
                      placeholder="Twitter"
                      {...product_register("twitter", {
                        required: false,
                      })}
                    />
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <g clipPath="url(#clip0_1009_6705)">
                        <path
                          d="M8 0C3.582 0 0 3.582 0 8C0 12.418 3.582 16 8 16C12.418 16 16 12.418 16 8C16 3.582 12.418 0 8 0ZM12.044 6.43C12.166 9.12333 10.1573 12.126 6.60133 12.126C5.52 12.126 4.514 11.8087 3.66667 11.2653C4.68267 11.3853 5.69667 11.1027 6.50133 10.4727C5.664 10.4573 4.95667 9.90333 4.712 9.14267C5.01267 9.2 5.30867 9.18333 5.57733 9.11C4.65667 8.92467 4.02067 8.09533 4.04133 7.208C4.3 7.35133 4.59467 7.43733 4.90867 7.44733C4.056 6.87733 3.81467 5.75133 4.316 4.89067C5.26 6.04933 6.67133 6.81133 8.26267 6.89133C7.98333 5.694 8.892 4.54 10.1287 4.54C10.6787 4.54 11.1767 4.77267 11.526 5.14467C11.962 5.05933 12.3727 4.89933 12.742 4.68C12.5987 5.12733 12.2953 5.502 11.9 5.73933C12.2873 5.69267 12.6567 5.59 12.9993 5.43733C12.7433 5.82267 12.4193 6.16 12.044 6.43V6.43Z"
                          fill="#6F757E"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_1009_6705">
                          <rect width="16" height="16" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                </div>

                {/* instagram */}
                <div className="col-lg-6">
                  <div className="add_user_input">
                    <input
                      type="text"
                      name="instagram"
                      className="form-control"
                      placeholder="Instagram"
                      {...product_register("instagram", {
                        required: false,
                      })}
                    />
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <g clipPath="url(#clip0_1009_8235)">
                        <path
                          d="M9.886 4.20133C9.394 4.17867 9.246 4.17467 8 4.17467C6.754 4.17467 6.60667 4.17933 6.11467 4.20133C4.84867 4.25933 4.25933 4.85867 4.20133 6.11467C4.17933 6.60667 4.174 6.754 4.174 8C4.174 9.246 4.17933 9.39333 4.20133 9.886C4.25933 11.1387 4.846 11.7413 6.11467 11.7993C6.606 11.8213 6.754 11.8267 8 11.8267C9.24667 11.8267 9.394 11.822 9.886 11.7993C11.152 11.742 11.7407 11.1407 11.7993 9.886C11.8213 9.394 11.826 9.246 11.826 8C11.826 6.754 11.8213 6.60667 11.7993 6.11467C11.7407 4.85933 11.1507 4.25933 9.886 4.20133V4.20133ZM8 10.3967C6.67667 10.3967 5.60333 9.324 5.60333 8C5.60333 6.67667 6.67667 5.604 8 5.604C9.32333 5.604 10.3967 6.67667 10.3967 8C10.3967 9.32333 9.32333 10.3967 8 10.3967ZM10.4913 6.06933C10.182 6.06933 9.93133 5.81867 9.93133 5.50933C9.93133 5.2 10.182 4.94933 10.4913 4.94933C10.8007 4.94933 11.0513 5.2 11.0513 5.50933C11.0513 5.818 10.8007 6.06933 10.4913 6.06933V6.06933ZM9.55533 8C9.55533 8.85933 8.85867 9.55533 8 9.55533C7.14133 9.55533 6.44467 8.85933 6.44467 8C6.44467 7.14067 7.14133 6.44467 8 6.44467C8.85867 6.44467 9.55533 7.14067 9.55533 8ZM8 0C3.582 0 0 3.582 0 8C0 12.418 3.582 16 8 16C12.418 16 16 12.418 16 8C16 3.582 12.418 0 8 0ZM12.6387 9.924C12.562 11.6207 11.6173 12.5607 9.92467 12.6387C9.42667 12.6613 9.26733 12.6667 8 12.6667C6.73267 12.6667 6.574 12.6613 6.076 12.6387C4.38 12.5607 3.43933 11.6193 3.36133 9.924C3.33867 9.42667 3.33333 9.26733 3.33333 8C3.33333 6.73267 3.33867 6.574 3.36133 6.076C3.43933 4.38 4.38067 3.43933 6.076 3.362C6.574 3.33867 6.73267 3.33333 8 3.33333C9.26733 3.33333 9.42667 3.33867 9.92467 3.362C11.6213 3.44 12.5627 4.38333 12.6387 6.076C12.6613 6.574 12.6667 6.73267 12.6667 8C12.6667 9.26733 12.6613 9.42667 12.6387 9.924Z"
                          fill="#6F757E"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_1009_8235">
                          <rect width="16" height="16" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                </div>

                {/* optional_acc */}
                <div className="col-lg-12">
                  <div className="add_user_input">
                    <textarea
                      name="optional_acc"
                      placeholder="More account links(optional)...."
                      {...product_register("optional_acc", {
                        required: false,
                      })}
                    ></textarea>
                  </div>
                </div>

                {/* submit & back button */}
                <div className="setp_btn row mt-3">
                  {currentStep > 1 && (
                    <div className="col-lg-6">
                      <p onClick={handleBack}>Back</p>
                    </div>
                  )}
                  {currentStep <= totalSteps && (
                    <div className="col-lg-6">
                      <div
                        className={`continue_step ${
                          currentStep === 1 ? "with_active_next_btn" : ""
                        }`}
                        onClick={() => {
                          if (currentStep === totalSteps) {
                            alert("Product Data is Done ");
                          } else if (
                            Object.keys(product_errors).length === 0 &&
                            checkProductFormValues()
                          ) {
                            handleNext();
                          } else {
                            console.log("there is still  data pending");
                          }
                        }}
                      >
                        <p className="active">
                          {currentStep === totalSteps ? "Save" : "Next"}
                        </p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </form>
        );
      case 4:
        return (
          <form>
            <div className="container">
              <h2> Pricing</h2>
              <div className="row from_wepper">
                {/* pricings */}
                <div className="col-lg-6">
                  <div className="form-group">
                    <label htmlFor="product_price">
                      Product Price
                      <span className="required_text">*</span>
                    </label>
                    <div className="add_user_input">
                      <input
                        type="text"
                        name="product_price"
                        id="product_price"
                        className="form-control"
                        placeholder="Price "
                        {...product_register("product_price", {
                          required: " * Product Price is required",
                        })}
                      />
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="19"
                        height="19"
                        viewBox="0 0 19 19"
                        fill="none"
                      >
                        <path
                          d="M15.5274 0H3.46875V2.39574H7.72122C9.2829 2.39574 10.6149 3.39718 11.1093 4.79149H3.46875V7.18723H11.1093C10.6149 8.58154 9.2829 9.58298 7.72122 9.58298H3.46875V11.9787L10.49 19L12.184 17.3059L6.85687 11.9788H7.72122C10.6136 11.9788 13.0337 9.91781 13.5902 7.18727H15.5274V4.79153H13.5902C13.4099 3.90684 13.0339 3.09255 12.5097 2.39578H15.5274V0Z"
                          fill="#6F757E"
                        />
                      </svg>
                    </div>
                    {product_errors?.product_price && (
                      <p id="alert" className="alert">
                        {product_errors?.product_price?.message}
                      </p>
                    )}
                  </div>
                </div>

                {/* is featured */}
                <div className="col-lg-6">
                  <div className="form-group">
                    <label htmlFor="is_featured">
                      is featured?
                      <span className="required_text">*</span>
                    </label>
                    <div className="add_user_input">
                      <select
                        id="is_featured"
                        name="is_featured"
                        className="form-control"
                        fdprocessedid="otsamo"
                        {...product_register("is_featured", {
                          required: " * Product Featured is required",
                        })}
                      >
                        <option value="" disabled>
                          Select If product is Featured or not ?
                        </option>
                        <option value={true}>Featured</option>
                        <option value={false}>Not Featured</option>
                      </select>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                      >
                        <path
                          d="M0 4.88667L1.886 3L8.00267 9.226L14.114 3L16 4.88667L8.00267 13L0 4.88667Z"
                          fill="#6F757E"
                        />
                      </svg>
                    </div>
                    {product_errors?.is_featured && (
                      <p id="alert" className="alert">
                        {product_errors?.is_featured?.message}
                      </p>
                    )}
                  </div>
                </div>

                {/* product status */}
                <div className="col-lg-6">
                  <div className="form-group">
                    <label htmlFor="product_status">
                      Product Status
                      <span className="required_text">*</span>
                    </label>
                    <div className="add_user_input">
                      <select
                        name="product_status"
                        id="product_status"
                        className="form-control"
                        fdprocessedid="otsamo"
                        {...product_register("product_status", {
                          required: " * Product Status is required",
                        })}
                      >
                        <option value="" disabled>
                          Select Product Status
                        </option>
                        <option value={true}>Active</option>
                        <option value={false}>In Active</option>
                      </select>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                      >
                        <path
                          d="M0 4.88667L1.886 3L8.00267 9.226L14.114 3L16 4.88667L8.00267 13L0 4.88667Z"
                          fill="#6F757E"
                        />
                      </svg>
                    </div>
                    {product_errors?.product_status && (
                      <p id="alert" className="alert">
                        {product_errors?.product_status?.message}
                      </p>
                    )}
                  </div>
                </div>

                {/* product Type */}
                <div className="col-lg-6">
                  <div className="form-group">
                    <label htmlFor="product_type">
                      Product Type
                      <span className="required_text">*</span>
                    </label>
                    <div className="add_user_input">
                      <select
                        name="product_type"
                        id="product_type"
                        className="form-control"
                        fdprocessedid="otsamo"
                        {...product_register("product_type", {
                          required: " * Product Type is required",
                        })}
                      >
                        <option value="" disabled>
                          Ex. Card, Hamper, Gift
                        </option>
                        {productTypeData.map((type, index) => (
                          <option key={index} value={type.id}>
                            {type.product_type_name}
                          </option>
                        ))}
                      </select>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                      >
                        <path
                          d="M0 4.88667L1.886 3L8.00267 9.226L14.114 3L16 4.88667L8.00267 13L0 4.88667Z"
                          fill="#6F757E"
                        />
                      </svg>
                    </div>
                  </div>
                </div>

                {/* product homepage Plament */}
                <div className="col-lg-6">
                  <div className="form-group">
                    <label htmlFor="product_placement">
                      Product Placement
                      <span className="required_text">*</span>
                    </label>
                    <div className="add_user_input">
                      <select
                        name="product_placement"
                        id="product_placement"
                        className="form-control"
                        {...product_register("product_placement", {
                          required: " * Product placement is required",
                        })}
                      >
                        <option defaultValue="">
                          Select Product Placement
                        </option>
                        <option value="top_trending_gifts">
                          Top Trending Gifts
                        </option>
                        {product_watch("product_type") == "1" && (
                          <option value="top_selling_hampers">
                            Top Selling Hampers
                          </option>
                        )}
                        {product_watch("product_type") == "1" && (
                          <option value="gift_hamper_of_the_week">
                            Gift Hamper of the week
                          </option>
                        )}
                        <option value="loved_ones_gifts">
                          Loved Ones gifts
                        </option>
                        <option value="generic_product">
                          Generic / Normal Product
                        </option>
                      </select>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="10"
                        viewBox="0 0 18 10"
                        fill="none"
                      >
                        <path
                          d="M2 1.5L9 8.5L16 1.5"
                          stroke="#26395C"
                          strokeWidth="2"
                          strokeLinecap="square"
                        ></path>
                      </svg>
                    </div>
                    {product_errors?.product_placement && (
                      <p id="alert" className="alert">
                        {product_errors?.product_placement?.message}
                      </p>
                    )}
                  </div>
                </div>

                {/* product top trending placement */}
                {product_watch("product_placement") ===
                  "top_trending_gifts" && (
                  <div className="col-lg-6">
                    <div className="form-group">
                      <label htmlFor="top_trending_section">
                        Top Trending Section
                        <span className="required_text">*</span>
                      </label>
                      <div className="add_user_input">
                        <select
                          name="top_trending_section"
                          id="top_trending_section"
                          className="form-control"
                          {...product_register("top_trending_section", {
                            required: " * Product Top Trending Section is required",
                          })}
                        >
                          <option defaultValue="">
                            Select Top Trending Section
                          </option>
                          <option value="best_seller">Best Seller</option>
                          <option value="new_arrival">New Arrival</option>
                          <option value="gift_hamper">Gift Hampers </option>
                          <option value="personalized_gifts">Personalized Gifts</option>
                        </select>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="10"
                          viewBox="0 0 18 10"
                          fill="none"
                        >
                          <path
                            d="M2 1.5L9 8.5L16 1.5"
                            stroke="#26395C"
                            strokeWidth="2"
                            strokeLinecap="square"
                          ></path>
                        </svg>
                      </div>
                      {product_errors?.top_trending_section && (
                        <p id="alert" className="alert">
                          {product_errors?.top_trending_section?.message}
                        </p>
                      )}
                    </div>
                  </div>
                )}

                {/* product attributes */}
                <div className="col-lg-6">
                  <div className="form-group">
                    <label htmlFor="product_attribute">Product Attribute</label>
                    <div className="add_user_input">
                      <select
                        name="product_attribute"
                        id="product_attribute"
                        fdprocessedid="otsamo"
                        value={selectedProductAttributes}
                        onChange={(e) => {
                          e.preventDefault();
                          console.log("ed.", e.target.value);
                          handleAttributeSelect(e.target.value);
                        }}
                        multiple
                        className="form-control styled-select"
                        style={{
                          width: "100%",
                          padding: "10px",
                          border: "1px solid #6F757E",
                          borderRadius: "5px",
                          height: "auto",
                          overflow: "auto",
                          boxSizing: "border-box",
                        }}
                        // {...product_register("product_attribute")}
                      >
                        <option defaultValue="Multi Select">
                          Multi Select
                        </option>
                        {attributeData.map((attribute, index) => (
                          <option
                            style={{
                              padding: "8px",
                              marginBottom: "5px",
                              borderBottom: "1px solid #f1f1f1",
                              color: "#333",
                            }}
                            key={index}
                            value={attribute.id}
                          >
                            {attribute.attributes_name} {"-"}{" "}
                            {attribute.attribute_unique_id}
                          </option>
                        ))}
                      </select>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                      >
                        <path
                          d="M0 4.88667L1.886 3L8.00267 9.226L14.114 3L16 4.88667L8.00267 13L0 4.88667Z"
                          fill="#6F757E"
                        />
                      </svg>
                    </div>
                  </div>
                </div>

                {/* is customer erquired */}
                <div className="col-lg-12">
                  <div className="container">
                    <div className="col-lg-12">
                      <div className="customer_requirement_wepper edit_profile_togle">
                        <p>
                          Is Customer Requirement Needed? (Like do we need any
                          name or photos)
                        </p>
                        <div className="toggle-row">
                          <label className="switch">
                            <input
                              type="checkbox"
                              id="is_customer_requirement"
                              name="is_customer_requirement"
                              checked={
                                product_watch("is_customer_requirement") ||
                                false
                              } // Controlled checkbox state
                              onChange={handleToggleChange} // If you need to handle custom toggle change
                              {...product_register("is_customer_requirement")}
                            />
                            <span className="slider"></span>
                          </label>
                        </div>
                      </div>
                    </div>

                    {/* Additional Requirement Count - Only visible when toggle is checked */}
                    {product_watch("is_customer_requirement") && (
                      <div className="col-lg-6">
                        <div className="form-group">
                          <label htmlFor="requirement_count">
                            Additional Requirement Count
                          </label>
                          <div className="add_user_input">
                            <div className="counter-box increment_btn_wepper">
                              <input
                                type="text"
                                value={count}
                                name="requirement_count"
                                id="requirement_count"
                                placeholder={
                                  count === 0
                                    ? "Add Count"
                                    : `Need ${count} Additional Requirement`
                                }
                                className="count_input form-control"
                                readOnly
                                {...product_register("requirement_count")}
                              />
                              <div className="buttons">
                                <button
                                  className="btn increment"
                                  onClick={(event) => {
                                    event.preventDefault();
                                    setCount(count + 1);
                                  }}
                                >
                                  {/* Increment SVG icon */}
                                </button>
                                <button
                                  className="btn decrement"
                                  onClick={(event) => {
                                    event.preventDefault();
                                    if (count > 0) setCount(count - 1);
                                  }}
                                >
                                  {/* Decrement SVG icon */}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                {rows.map((_, index) => (
                  <div className="row" key={index}>
                    {/* Text Input */}
                    <div className="col-lg-4">
                      <div className="form-group">
                        <label htmlFor={`text_${index}`}>Text Required</label>
                        <div className="add_user_input">
                          <input
                            type="text"
                            id={`text_${index}`}
                            name={`text_${index}`} // Ensure unique names for each input
                            className="form-control"
                            placeholder="EX.- Provide name"
                            {...product_register(`text_${index}`, {
                              required: true,
                            })}
                          />
                        </div>
                      </div>
                    </div>

                    {/* Select Input */}
                    <div className="col-lg-4">
                      <div className="form-group">
                        <label htmlFor={`requirement_type_${index}`}>
                          Additional Requirement Type
                        </label>
                        <div className="add_user_input">
                          <select
                            name={`requirement_type_${index}`} // Ensure unique names for each input
                            id={`requirement_type_${index}`}
                            className="form-control"
                            {...product_register(`requirement_type_${index}`)}
                          >
                            {/* "text", "number", "date", "time", "file", "image" */}
                            <option value="text">Text</option>
                            <option value="number">Number</option>
                            <option value="date">Date</option>
                            <option value="time">Time</option>
                            <option value="file">File</option>
                            <option value="image">Image</option>
                          </select>
                        </div>
                      </div>
                    </div>

                    {/* Customer Display Text Input */}
                    <div className="col-lg-4">
                      <div className="form-group">
                        <label htmlFor={`requirement_customerDisplay_${index}`}>
                          Additional Requirement Text Should
                        </label>
                        <div className="add_user_input">
                          <input
                            type="text"
                            id={`requirement_customerDisplay_${index}`}
                            name={`requirement_customerDisplay_${index}`} // Ensure unique names for each input
                            className="form-control"
                            placeholder="EX.- Provide name"
                            {...product_register(
                              `requirement_customerDisplay_${index}`
                            )}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                ))}

                {/* submit or next */}
                <div className="setp_btn row mt-3">
                  {currentStep > 1 && (
                    <div className="col-lg-6">
                      <p onClick={handleBack}>Back</p>
                    </div>
                  )}
                  {currentStep <= totalSteps && (
                    <div className="col-lg-6">
                      <div
                        style={
                          product_errors.length > 0
                            ? { cursor: "disabled" }
                            : { cursor: "pointer" }
                        }
                        className={`continue_step ${
                          currentStep === 1 ? "with_active_next_btn" : ""
                        }`}
                        onClick={
                          currentStep === totalSteps
                            ? () => {
                                product_handleSubmit(handleProductSubmitForm)();
                              }
                            : handleNext
                        }
                      >
                        <p className="active">
                          {currentStep === totalSteps ? "Save" : "Next"}
                        </p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </form>
        );

      default:
        return (
          <div className="container">
            <h2>Step {step}: Content Not Available</h2>
          </div>
        );
    }
  };

  const renderStepContentCategoryInfo = (step) => {
    switch (step) {
      case 1:
        return (
          <form onSubmit={category_handleSubmit(categoryFormSubmit)}>
            <div className="container">
              {/* <h2> Product Information</h2> */}
              <div className="row from_wepper">
                {/* categoryName */}
                <div className="col-lg-6">
                  <div className="form-group ">
                    <label htmlFor="fname">
                      Categories name <span className="required_text"> *</span>
                    </label>
                    <div className="add_user_input">
                      <input
                        type="text"
                        name="fname"
                        className="form-control"
                        placeholder="Jone"
                        {...category_register("category_name", {
                          required: "* Category Name is required",
                        })}
                      />
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                      >
                        <g clipPath="url(#clip0_771_7773)">
                          <path
                            d="M12.6667 4.66733C12.6667 7.244 10.5773 9.334 8 9.334C5.42267 9.334 3.33333 7.244 3.33333 4.66733C3.33333 2.08933 5.42267 0 8 0C10.5773 0 12.6667 2.08933 12.6667 4.66733V4.66733ZM11.6013 9.454C10.5973 10.212 9.352 10.6673 8 10.6673C6.64667 10.6673 5.40067 10.2107 4.39533 9.45267C1.68067 10.648 0 14.37 0 16H16C16 14.3847 14.2667 10.6627 11.6013 9.454V9.454Z"
                            fill="#6F757E"
                          ></path>
                        </g>
                        <defs>
                          <clipPath id="clip0_771_7773">
                            <rect width="16" height="16" fill="white"></rect>
                          </clipPath>
                        </defs>
                      </svg>
                    </div>
                    {category_errors?.category_name && (
                      <p className="alert">
                        {category_errors.category_name.message}
                      </p>
                    )}
                  </div>
                </div>

                {/* categoryDescription */}
                <div className="col-lg-6">
                  <div className="form-group ">
                    <label htmlFor="fname">
                      Description
                      <span className="required_text"> *</span>
                    </label>
                    <div className="add_user_input">
                      <input
                        type="text"
                        name="fname"
                        className="form-control"
                        placeholder="Category Description"
                        {...category_register("category_description", {
                          required: "* Category Description is required",
                        })}
                      />
                    </div>
                    {category_errors?.category_description && (
                      <p className="alert">
                        {category_errors.category_description.message}
                      </p>
                    )}
                  </div>
                </div>

                {/* category level */}
                <div className="col-lg-6">
                  <div className="form-group">
                    <label htmlFor="category_level">
                      Select Category Level
                    </label>
                    <div className="add_user_input">
                      <select
                        name="category_level"
                        className="form-control"
                        {...category_register("category_level", {
                          required: "* Parent Category is required",
                        })}
                      >
                        <option value="" disabled>
                          Select Category Level
                        </option>
                        <option value="level1_right_down_slider">
                          Level 1 (Below Slider)
                        </option>
                        <option value="level2_promotedCategory">
                          Promoted Category
                        </option>
                        <option value="level3_meaningfulCategory">
                          Meaningful Connection
                        </option>
                        <option value="normal_category">Normal Category</option>
                      </select>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="10"
                        viewBox="0 0 18 10"
                        fill="none"
                      >
                        <path
                          d="M2 1.5L9 8.5L16 1.5"
                          stroke="#26395C"
                          strokeWidth="2"
                          strokeLinecap="square"
                        ></path>
                      </svg>
                    </div>
                  </div>
                </div>

                {/* is it a parent category */}
                <div className="col-lg-6">
                  <div className="form-group">
                    <label htmlFor="fname">
                      Is it a parent category?
                      <span className="required_text"> *</span>
                    </label>
                    <div className="add_user_input">
                      <select
                        name="category"
                        className="form-control"
                        {...category_register("is_parent", {
                          required: "* Parent field is required",
                        })}
                      >
                        <option value="" disabled>
                          Yes/No
                        </option>
                        <option value="true">
                          Yes, it is a parent Category
                        </option>
                        <option value="false">No, It is not.</option>
                      </select>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="10"
                        viewBox="0 0 18 10"
                        fill="none"
                      >
                        <path
                          d="M2 1.5L9 8.5L16 1.5"
                          stroke="#26395C"
                          strokeWidth="2"
                          strokeLinecap="square"
                        ></path>
                      </svg>
                    </div>
                    {category_errors?.is_parent && (
                      <p className="alert">
                        {category_errors.is_parent.message}
                      </p>
                    )}
                  </div>
                </div>

                {/* select parent category */}
                {category_watch("is_parent") === "false" && (
                  <div className="col-lg-6">
                    <div className="form-group">
                      <label htmlFor="fname">Select Parent Category</label>
                      <div className="add_user_input">
                        <select
                          name="category"
                          className="form-control"
                          {...category_register("parent_category_id", {
                            required:
                              category_watch("is_parent") === "false"
                                ? "* Parent Category is required"
                                : "",
                          })}
                        >
                          <option value="" disabled>
                            {parentCategoryData.length > 0
                              ? "Select Parent"
                              : "No Parent Category Found"}
                          </option>
                          {parentCategoryData.length > 0 &&
                            parentCategoryData.map((category, index) => (
                              <option key={index} value={category?.id}>
                                {category?.name}
                              </option>
                            ))}
                        </select>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="10"
                          viewBox="0 0 18 10"
                          fill="none"
                        >
                          <path
                            d="M2 1.5L9 8.5L16 1.5"
                            stroke="#26395C"
                            strokeWidth="2"
                            strokeLinecap="square"
                          ></path>
                        </svg>
                      </div>
                    </div>
                  </div>
                )}

                {/* submit or next */}
                <div className="setp_btn row mt-3">
                  {currentCategoryStep > 1 && (
                    <div className="col-lg-6">
                      <p onClick={handleCategoryBack}>Back</p>
                    </div>
                  )}
                  {currentCategoryStep <= categorySteps && (
                    <div className="col-lg-6">
                      <div
                        style={
                          category_errors.length > 0
                            ? { cursor: "disabled" }
                            : { cursor: "pointer" }
                        }
                        className={`continue_step ${
                          currentCategoryStep === 1
                            ? "with_active_next_btn"
                            : ""
                        }`}
                        onClick={() => {
                          // Check if there are no errors before calling handleCategoryNext
                          if (currentCategoryStep === categorySteps) {
                            alert("Categories Data is Done");
                          } else if (
                            Object.keys(category_errors).length === 0 &&
                            checkCategoryFormValues()
                          ) {
                            handleCategoryNext(); // Call handleCategoryNext only if no errors
                          } else {
                            console.log("There are errors, cannot proceed.");
                          }
                        }}
                      >
                        <p className="active">
                          {currentCategoryStep === categorySteps
                            ? "Save"
                            : "Next"}
                        </p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </form>
        );
      case 2:
        return (
          <form>
            <div className="container">
              <h2>Media</h2>
              <div className="row form_wepper">
                <div className="col-lg-12">
                  <div className="media_upload_container">
                    <div className="media_preview_row">
                      {uploadCategoryImages.map((image, index) => (
                        <div key={index} className="media_preview_slot">
                          <img
                            src={image}
                            alt={`Uploaded Preview ${index + 1}`}
                            className="uploaded_image"
                            required="true"
                          />
                          <button
                            className="close_icon"
                            onClick={(e) => {
                              e.preventDefault();
                              setUploadedCategoryImages((prevImages) =>
                                prevImages.filter(
                                  (_, imgIndex) => imgIndex !== index
                                )
                              );
                            }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="13"
                              height="12"
                              viewBox="0 0 13 12"
                              fill="none"
                            >
                              <path
                                d="M6.5 0C3.20445 0 0.5 2.70445 0.5 6C0.5 9.29555 3.20445 12 6.5 12C9.79555 12 12.5 9.29555 12.5 6C12.5 2.70445 9.79555 0 6.5 0ZM9.48312 7.98886L8.48886 8.98312L6.5 6.99427L4.51114 8.98312L3.51688 7.98886L5.50573 6L3.51688 4.01114L4.51114 3.01688L6.5 5.00573L8.48886 3.01688L9.48312 4.01114L7.49427 6L9.48312 7.98886Z"
                                fill="#313131"
                              />
                            </svg>
                          </button>
                        </div>
                      ))}
                    </div>
                    <div className="upload_area">
                      <input
                        type="file"
                        name="media"
                        className="file_input"
                        multiple
                        accept="image/jpeg, image/jpg, image/png"
                        onChange={handleFileUploadCategory}
                      />
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="65"
                        height="64"
                        viewBox="0 0 65 64"
                        fill="none"
                      >
                        <g clipPath="url(#clip0_900_10944)">
                          <path
                            d="M52.444 26.912C51.8787 16.376 43.1827 8 32.5 8C21.82 8 13.1213 16.376 12.556 26.912C5.70267 28.1467 0.5 34.128 0.5 41.3333C0.5 49.432 7.068 56 15.1667 56H49.8333C57.932 56 64.5 49.432 64.5 41.3333C64.5 34.128 59.2973 28.1467 52.444 26.912ZM32.5 24L43.1667 34.6667H35.1667V45.3333H29.8333V34.6667H21.8333L32.5 24Z"
                            fill="#10849B"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_900_10944">
                            <rect
                              width="64"
                              height="64"
                              fill="white"
                              transform="translate(0.5)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                      <i className="upload_icon"></i>
                      <p>
                        Drop your image here or{" "}
                        <span className="browse_link">Browse</span>
                      </p>
                      <p className="supported_formats">
                        Support: JPG, JPEG, PNG
                      </p>
                    </div>
                  </div>
                </div>

                {/* submit or next */}
                <div className="setp_btn row mt-3">
                  {currentCategoryStep > 1 && (
                    <div className="col-lg-6">
                      <p onClick={handleCategoryBack}>Back</p>
                    </div>
                  )}
                  {currentCategoryStep <= categorySteps && (
                    <div className="col-lg-6">
                      <div
                        style={
                          category_errors.length > 0
                            ? { cursor: "disabled" }
                            : { cursor: "pointer" }
                        }
                        className={`continue_step ${
                          currentCategoryStep === 1
                            ? "with_active_next_btn"
                            : ""
                        }`}
                        onClick={
                          currentCategoryStep === categorySteps
                            ? () => category_handleSubmit(categoryFormSubmit)()
                            : handleCategoryNext
                        }
                      >
                        <p className="active">
                          {currentCategoryStep === categorySteps
                            ? "Save"
                            : "Next"}
                        </p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </form>
        );
    }
  };

  return (
    <div>
      <AdminLayout>
        <div className="add_new_product_wepper">
          <div className="add_net_product_inner">
            {/* <h2>Add New Product</h2>
                        <p>This information will describe more about the product.</p> */}
          </div>
          <div className="add_new_product_left_side_wepper">
            <div className="d-flex align-items-start">
              <div
                className="nav flex-column nav-pills add_new_product_left_side_inner_bg"
                id="v-pills-tab"
                role="tablist"
                aria-orientation="vertical"
              >
                <button
                  className="nav-link active"
                  id="Product"
                  data-bs-toggle="pill"
                  data-bs-target="#v-pills-home"
                  type="button"
                  role="tab"
                  aria-controls="v-pills-home"
                  aria-selected="true"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="19"
                    viewBox="0 0 18 19"
                    fill="none"
                  >
                    <g clipPath="url(#clip0_1010_12578)">
                      <path
                        d="M14.25 5.75075C14.25 8.6495 11.8995 11.0008 9 11.0008C6.1005 11.0008 3.75 8.6495 3.75 5.75075C3.75 2.8505 6.1005 0.5 9 0.5C11.8995 0.5 14.25 2.8505 14.25 5.75075ZM13.0515 11.1357C11.922 11.9885 10.521 12.5007 9 12.5007C7.4775 12.5007 6.07575 11.987 4.94475 11.1342C1.89075 12.479 0 16.6663 0 18.5H18C18 16.6828 16.05 12.4955 13.0515 11.1357Z"
                        fill="#050F24"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_1010_12578">
                        <rect
                          width="18"
                          height="18"
                          fill="white"
                          transform="translate(0 0.5)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                  Product
                </button>
                <button
                  className="nav-link"
                  id="Categories"
                  data-bs-toggle="pill"
                  data-bs-target="#v-pills-profile"
                  type="button"
                  role="tab"
                  aria-controls="v-pills-profile"
                  aria-selected="false"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="19"
                    viewBox="0 0 18 19"
                    fill="none"
                  >
                    <g clipPath="url(#clip0_1010_11812)">
                      <path
                        d="M16.5 10.25V0.5H1.5V18.5H7.80675C11.4495 18.5 10.308 12.5 10.308 12.5C12.5648 13.0588 16.5 12.8142 16.5 10.25ZM13.5 5H4.5V4.25H13.5V5ZM13.5 7.25H4.5V6.5H13.5V7.25ZM13.5 9.5H4.5V8.75H13.5V9.5ZM11.9318 14.1672C13.467 14.5257 15.5355 13.958 16.5 13.283C15.3795 14.7815 12.5775 17.564 10.926 18.4437C11.793 17.5677 12.0983 15.2682 11.9318 14.1672Z"
                        fill="#050F24"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_1010_11812">
                        <rect
                          width="18"
                          height="18"
                          fill="white"
                          transform="translate(0 0.5)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                  Categories
                </button>
                <button
                  className="nav-link"
                  id="Attribute"
                  data-bs-toggle="pill"
                  data-bs-target="#v-pills-messages"
                  type="button"
                  role="tab"
                  aria-controls="v-pills-messages"
                  aria-selected="false"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="19"
                    viewBox="0 0 18 19"
                    fill="none"
                  >
                    <g clipPath="url(#clip0_1010_11910)">
                      <path
                        d="M12.75 7.82075V4.25C12.75 2.17925 11.0715 0.5 9 0.5C6.92775 0.5 5.25 2.17925 5.25 4.25V7.82075C3.87975 8.92025 3 10.6062 3 12.5C3 15.8135 5.6865 18.5 9 18.5C12.3135 18.5 15 15.8135 15 12.5C15 10.6062 14.1202 8.92025 12.75 7.82075ZM9 14C8.172 14 7.5 13.328 7.5 12.5C7.5 11.672 8.172 11 9 11C9.828 11 10.5 11.672 10.5 12.5C10.5 13.328 9.828 14 9 14ZM11.25 6.94025C10.5547 6.65825 9.7965 6.5 9 6.5C8.2035 6.5 7.44525 6.65825 6.75 6.94025V4.25C6.75 3.0095 7.7595 2 9 2C10.2405 2 11.25 3.0095 11.25 4.25V6.94025Z"
                        fill="#050F24"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_1010_11910">
                        <rect
                          width="18"
                          height="18"
                          fill="white"
                          transform="translate(0 0.5)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                  Attribute
                </button>
                <button
                  className="nav-link"
                  id="ProductType"
                  data-bs-toggle="pill"
                  data-bs-target="#v-pills-settings"
                  type="button"
                  role="tab"
                  aria-controls="v-pills-settings"
                  aria-selected="false"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="19"
                    viewBox="0 0 18 19"
                    fill="none"
                  >
                    <g clipPath="url(#clip0_1010_11910)">
                      <path
                        d="M12.75 7.82075V4.25C12.75 2.17925 11.0715 0.5 9 0.5C6.92775 0.5 5.25 2.17925 5.25 4.25V7.82075C3.87975 8.92025 3 10.6062 3 12.5C3 15.8135 5.6865 18.5 9 18.5C12.3135 18.5 15 15.8135 15 12.5C15 10.6062 14.1202 8.92025 12.75 7.82075ZM9 14C8.172 14 7.5 13.328 7.5 12.5C7.5 11.672 8.172 11 9 11C9.828 11 10.5 11.672 10.5 12.5C10.5 13.328 9.828 14 9 14ZM11.25 6.94025C10.5547 6.65825 9.7965 6.5 9 6.5C8.2035 6.5 7.44525 6.65825 6.75 6.94025V4.25C6.75 3.0095 7.7595 2 9 2C10.2405 2 11.25 3.0095 11.25 4.25V6.94025Z"
                        fill="#050F24"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_1010_11910">
                        <rect
                          width="18"
                          height="18"
                          fill="white"
                          transform="translate(0 0.5)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                  Product Type
                </button>
              </div>
              <div className="tab-content" id="v-pills-tabContent">
                <div
                  className="tab-pane fade show active"
                  id="v-pills-home"
                  role="tabpanel"
                  aria-labelledby="v-pills-home-tab"
                  tabIndex="0"
                >
                  <div>
                    <div className="product_information_wepper">
                      <div className="product_information_inner_bg">
                        <div className="progress_wepper">
                          {[...Array(totalSteps)].map((_, index) => {
                            const step = index + 1;
                            const isActive = step === currentStep;
                            const isCompleted = step < currentStep;

                            return (
                              <div key={step}>
                                <div
                                  className={`progress_inner ${
                                    isActive ? "active" : ""
                                  } ${isCompleted ? "completed" : ""}`}
                                >
                                  <div
                                    className={`dot_withie ${
                                      isActive ? "yellow" : "white"
                                    }`}
                                  ></div>
                                  {step !== totalSteps && (
                                    <div
                                      className={`divider_progrss_line ${
                                        isCompleted ? "yellow" : "white"
                                      }`}
                                    ></div>
                                  )}
                                </div>
                                {/* Update h3 color conditionally */}
                                <h3
                                  className={`${
                                    isActive || isCompleted
                                      ? "progress_wepper_white_text"
                                      : ""
                                  }`}
                                >
                                  {stepLabels[index]}
                                </h3>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                      {/* {renderStepContent(currentStep)} */}
                      <RenderStepContent step={currentStep} />
                    </div>
                  </div>
                </div>
                <div
                  className="tab-pane fade category_info_wepper"
                  id="v-pills-profile"
                  role="tabpanel"
                  aria-labelledby="v-pills-profile-tab"
                  tabIndex="0"
                >
                  <div className="product_information_wepper">
                    <div className="product_information_inner_bg">
                      <div className="progress_wepper">
                        {[...Array(categorySteps)].map((_, index) => {
                          const step = index + 1;
                          const isActive = step === currentCategoryStep;
                          const isCompleted = step < currentCategoryStep;

                          return (
                            <div key={step}>
                              <div
                                className={`progress_inner ${
                                  isActive ? "active" : ""
                                } ${isCompleted ? "completed" : ""}`}
                              >
                                <div
                                  className={`dot_withie ${
                                    isActive ? "yellow" : "white"
                                  }`}
                                ></div>
                                {step !== categorySteps && (
                                  <div
                                    className={`divider_progrss_line ${
                                      isCompleted ? "yellow" : "white"
                                    }`}
                                  ></div>
                                )}
                              </div>

                              <h3
                                className={`${
                                  isActive || isCompleted
                                    ? "progress_wepper_white_text"
                                    : ""
                                }`}
                              >
                                {categoryLabels[index]}
                              </h3>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                    {renderStepContentCategoryInfo(currentCategoryStep)}
                  </div>
                </div>
                <div
                  className="tab-pane fade"
                  id="v-pills-messages"
                  role="tabpanel"
                  aria-labelledby="v-pills-messages-tab"
                  tabIndex="0"
                >
                  <form>
                    <div className="container product_information_wepper">
                      <h2>Product Attribute</h2>
                      <div className="row from_wepper">
                        {/* attribute name */}
                        <div className="col-lg-6">
                          <div className="form-group ">
                            <label htmlFor="fname">
                              Attribute Name
                              <span className="required_text"> *</span>
                            </label>
                            <div className="add_user_input">
                              <input
                                type="text"
                                name="fname"
                                className="form-control"
                                placeholder="Color "
                                {...attribute_register("attributes_name", {
                                  required: "* Attribute Name is required",
                                })}
                              />
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="23"
                                height="22"
                                viewBox="0 0 23 22"
                                fill="none"
                              >
                                <g clipPath="url(#clip0_1069_11526)">
                                  <path
                                    d="M22.5353 2.63933C22.4923 2.53519 22.3931 2.4619 22.2769 2.4483C22.161 2.43476 22.0461 2.48304 21.9781 2.5742C21.5745 3.11551 21.0448 3.29594 20.4313 3.5049C19.9365 3.67347 19.4249 3.84764 18.872 4.22736C18.09 4.76434 17.7323 5.49633 17.9107 6.19011L17.8916 6.21349C17.5651 5.76039 17.2098 5.3413 16.8349 4.96709C15.0807 3.21629 12.6296 2.16372 10.1097 2.07933C9.99874 2.07561 9.88592 2.07373 9.77443 2.07373C6.96077 2.07373 4.26765 3.27685 2.38569 5.37451C0.51357 7.46132 -0.316215 10.1779 0.109193 12.8276C0.144759 13.0491 0.18927 13.2728 0.241607 13.4928C0.933548 16.406 2.70083 18.6221 5.09036 19.5727C5.67938 19.8071 6.27351 19.9259 6.85604 19.9259C8.30333 19.9259 9.56747 19.1854 10.3244 17.8944C10.6121 17.4032 10.7978 16.8952 10.876 16.3844C10.9221 16.0829 10.8906 15.7816 10.86 15.4897C10.8286 15.1892 10.7989 14.9053 10.8464 14.6194C10.9554 13.964 11.434 13.5726 12.1267 13.5726C12.3238 13.5726 12.5252 13.6037 12.7262 13.6649C12.4908 14.0779 12.277 14.4723 12.0902 14.8379C11.6942 15.6126 11.4211 16.2542 11.2781 16.7446C11.19 17.0471 10.9559 17.8509 11.5267 18.2299C11.708 18.3502 11.9379 18.3927 12.1771 18.3501C12.3927 18.3118 13.0486 18.1952 14.9126 16.1655C15.4129 15.6209 15.952 14.9905 16.5154 14.2917C17.9619 13.8257 19.0876 12.666 19.3854 11.3335C19.4599 11.0003 19.491 10.6438 19.4777 10.2735C20.0193 9.47296 20.4943 8.72596 20.9724 7.92293C20.9815 7.90745 20.9906 7.89095 20.9995 7.87404C21.6933 7.69228 22.2909 7.17582 22.6416 6.45361C23.1537 5.39956 23.116 4.04489 22.5353 2.63933ZM14.7154 7.6305C14.4645 8.0117 14.0332 8.23929 13.5615 8.23929C13.3054 8.23929 13.0549 8.16998 12.8372 8.03879C12.5293 7.85331 12.3152 7.5643 12.2347 7.22497C12.1541 6.88563 12.2163 6.53652 12.4103 6.24201C12.6612 5.86082 13.0926 5.63322 13.5643 5.63322C13.8204 5.63322 14.0709 5.70253 14.2886 5.83377C14.5964 6.01915 14.8105 6.30817 14.8911 6.64755C14.9716 6.98693 14.9093 7.33599 14.7154 7.6305ZM16.4835 9.99115C17.1721 9.02062 17.9004 8.0559 18.5921 7.19777C18.7042 7.29463 18.8296 7.38926 18.9654 7.4794C19.1905 7.62877 19.4259 7.74428 19.6663 7.82337C19.0823 8.77867 18.4544 9.72511 17.694 10.7963C16.4448 12.5569 15.1459 14.1923 14.0365 15.4014C13.4169 16.0767 12.8746 16.5981 12.4568 16.921C12.6181 16.4275 12.9263 15.7502 13.3553 14.9477C14.1223 13.5128 15.2333 11.7525 16.4835 9.99115ZM4.39283 9.9828C4.13668 9.9828 3.88617 9.91349 3.66835 9.78225C3.3605 9.59682 3.14652 9.30791 3.06591 8.96847C2.9853 8.62909 3.0477 8.27998 3.24167 7.98547C3.49249 7.60433 3.92386 7.37673 4.39549 7.37673C4.65169 7.37673 4.9022 7.44604 5.11996 7.57728C5.75546 7.96016 5.94692 8.76619 5.54691 9.37396C5.29582 9.75521 4.86439 9.9828 4.39283 9.9828ZM2.96497 12.8518C3.2159 12.4706 3.64722 12.243 4.11889 12.243C4.37499 12.243 4.62544 12.3123 4.84331 12.4435C5.15116 12.629 5.36514 12.9179 5.44575 13.2573C5.52641 13.5966 5.46401 13.9456 5.27 14.2403C5.01917 14.6213 4.5878 14.849 4.11618 14.849C3.86003 14.849 3.60947 14.7797 3.3916 14.6484C3.08375 14.463 2.86982 14.1741 2.78927 13.8347C2.70876 13.4954 2.77122 13.1463 2.96497 12.8518ZM7.32724 5.11366C7.57817 4.73246 8.00954 4.50487 8.48116 4.50487C8.73721 4.50487 8.98771 4.57418 9.20548 4.70537C9.84103 5.08814 10.0325 5.89422 9.63243 6.5021C9.38139 6.88334 8.95002 7.11094 8.4784 7.11094C8.2223 7.11094 7.97179 7.04163 7.75403 6.91038C7.44624 6.72501 7.23231 6.43604 7.1517 6.09661C7.07098 5.75728 7.13338 5.40822 7.32724 5.11366Z"
                                    fill="#6F757E"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_1069_11526">
                                    <rect width="23" height="22" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>
                            </div>
                            {attribute_errors.attributes_name && (
                              <p className="alert" id="alert">
                                {attribute_errors?.attributes_name?.message}
                              </p>
                            )}
                          </div>
                        </div>

                        {/* attribute Value */}
                        <div className="col-lg-6">
                          <div className="form-group ">
                            <label htmlFor="fname">
                              Value
                              <span className="required_text"> *</span>
                            </label>
                            <div className="add_user_input">
                              <input
                                type="text"
                                name="fname"
                                className="form-control"
                                placeholder="Green etc... "
                                {...attribute_register("attributes_value", {
                                  required: "* Attribute Value is required",
                                })}
                              />
                            </div>
                            {attribute_errors.attributes_value && (
                              <p className="alert" id="alert">
                                {attribute_errors?.attributes_value?.message}
                              </p>
                            )}
                          </div>
                        </div>

                        {/* attribute Unique id */}
                        <div className="col-lg-6">
                          <div className="form-group ">
                            <label htmlFor="fname">
                              Attribute Unique Id
                              <span className="required_text"> *</span>
                            </label>
                            <div className="add_user_input">
                              <input
                                type="text"
                                name="fname"
                                className="form-control"
                                placeholder="UNBOXED_111, or etc... "
                                {...attribute_register("attribute_unique_id", {
                                  required: "* Attribute Unique Id is required",
                                })}
                              />
                            </div>
                            {attribute_errors.attribute_unique_id && (
                              <p className="alert" id="alert">
                                {attribute_errors?.attribute_unique_id?.message}
                              </p>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="row form_wepper">
                        <div className="col-lg-12">
                          <div className="media_upload_container">
                            <div className="media_preview_row">
                              {uploadedImagesAttribute.map((image, index) => (
                                <div key={index} className="media_preview_slot">
                                  <img
                                    src={image}
                                    alt={`Uploaded Preview ${index + 1}`}
                                    className="uploaded_image"
                                  />
                                  <button
                                    className="close_icon"
                                    onClick={() => {
                                      setUploadedAttributeImages((prevImages) =>
                                        prevImages.filter(
                                          (_, imgIndex) => imgIndex !== index
                                        )
                                      );
                                    }}
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="13"
                                      height="12"
                                      viewBox="0 0 13 12"
                                      fill="none"
                                    >
                                      <path
                                        d="M6.5 0C3.20445 0 0.5 2.70445 0.5 6C0.5 9.29555 3.20445 12 6.5 12C9.79555 12 12.5 9.29555 12.5 6C12.5 2.70445 9.79555 0 6.5 0ZM9.48312 7.98886L8.48886 8.98312L6.5 6.99427L4.51114 8.98312L3.51688 7.98886L5.50573 6L3.51688 4.01114L4.51114 3.01688L6.5 5.00573L8.48886 3.01688L9.48312 4.01114L7.49427 6L9.48312 7.98886Z"
                                        fill="#313131"
                                      />
                                    </svg>
                                  </button>
                                </div>
                              ))}
                            </div>
                            <div className="upload_area">
                              <input
                                type="file"
                                name="media"
                                className="file_input"
                                multiple
                                accept="image/jpeg, image/jpg, image/png"
                                onChange={handleFileUploadAttribute}
                              />
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="65"
                                height="64"
                                viewBox="0 0 65 64"
                                fill="none"
                              >
                                <g clipPath="url(#clip0_900_10944)">
                                  <path
                                    d="M52.444 26.912C51.8787 16.376 43.1827 8 32.5 8C21.82 8 13.1213 16.376 12.556 26.912C5.70267 28.1467 0.5 34.128 0.5 41.3333C0.5 49.432 7.068 56 15.1667 56H49.8333C57.932 56 64.5 49.432 64.5 41.3333C64.5 34.128 59.2973 28.1467 52.444 26.912ZM32.5 24L43.1667 34.6667H35.1667V45.3333H29.8333V34.6667H21.8333L32.5 24Z"
                                    fill="#10849B"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_900_10944">
                                    <rect
                                      width="64"
                                      height="64"
                                      fill="white"
                                      transform="translate(0.5)"
                                    />
                                  </clipPath>
                                </defs>
                              </svg>
                              <i className="upload_icon"></i>
                              <p>
                                Drop your image here or{" "}
                                <span className="browse_link">Browse</span>
                              </p>
                              <p className="supported_formats">
                                Support: JPG, JPEG, PNG
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="setp_btn row mt-3">
                        {currentCategoryStep <= categorySteps && (
                          <div className="col-lg-6">
                            <div
                              className={`continue_step "with_active_next_btn"`}
                              onClick={attribute_handleSubmit(
                                attributeFormSubmit
                              )}
                            >
                              <p className="active">
                                {checkAttributeUnfilledValue
                                  ? "Save Attribute"
                                  : ""}
                              </p>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </form>
                </div>
                <div
                  className="tab-pane fade"
                  id="v-pills-settings"
                  role="tabpanel"
                  aria-labelledby="v-pills-settings-tab"
                  tabIndex="0"
                >
                  <form>
                    <div className="container product_information_wepper">
                      <h2>Add New Product Type</h2>
                      <div className="row from_wepper">
                        <div className="col-lg-6">
                          <div className="form-group ">
                            <label htmlFor="fname">
                              Product Type Name
                              <span className="required_text"> *</span>
                            </label>
                            <div className="add_user_input">
                              <input
                                type="text"
                                name="fname"
                                className="form-control"
                                placeholder="Hamper/ Gift Box/ etc.."
                                {...productType_register("product_type_name", {
                                  required: "* Product Type Name is required",
                                })}
                              />
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                              >
                                <g clipPath="url(#clip0_1074_6085)">
                                  <path
                                    d="M12.6667 4.66733C12.6667 7.244 10.5773 9.334 8 9.334C5.42267 9.334 3.33333 7.244 3.33333 4.66733C3.33333 2.08933 5.42267 0 8 0C10.5773 0 12.6667 2.08933 12.6667 4.66733V4.66733ZM11.6013 9.454C10.5973 10.212 9.352 10.6673 8 10.6673C6.64667 10.6673 5.40067 10.2107 4.39533 9.45267C1.68067 10.648 0 14.37 0 16H16C16 14.3847 14.2667 10.6627 11.6013 9.454V9.454Z"
                                    fill="#6F757E"
                                  />
                                </g>
                                <defs>
                                  <clipPath id="clip0_1074_6085">
                                    <rect width="16" height="16" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>
                            </div>
                            {productType_errors.product_type_name && (
                              <p className="alert" id="alert">
                                {productType_errors?.product_type_name?.message}
                              </p>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="setp_btn row mt-3">
                        {/* {currentCategoryStep > 1 && (
                          <div className="col-lg-6">
                            <p onClick={handleCategoryBack}>Back</p>
                          </div>
                        )} */}
                        {currentCategoryStep <= categorySteps && (
                          <div className="col-lg-6">
                            <div
                              className={`continue_step ${
                                currentCategoryStep === 1
                                  ? "with_active_next_btn"
                                  : ""
                              }`}
                              onClick={productType_handleSubmit(
                                createProductType
                              )}
                            >
                              <p className="active">Save Product Type</p>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </AdminLayout>
    </div>
  );
};

export default NewProduct;
